export default {
  user: null,
  isLogged: false,
  error: false,
  errorMessage: "",
  success: false,
  successMessage: "",
  role: null,
  successPassword: false,
  passwordMessage: "",
  passwordErrorMsg: "",
  errorPassword: false,
  info: null,
};
